export interface Product {
  id: number;
  name: string;
  fullName: string;
  category: string;
  catalogType: 'Producción' | 'Perforación';
  description: string;
  applications: string[];
  specs: string[];
  treatment?: string;
  badge?: string;
  badgeColor?: string;
  icon: string;
  stockDrum: number;
  stockTote: number;
}

export const allProducts: Product[] = [
  // ─── CATÁLOGO PRODUCCIÓN ───────────────────────────────────────────────
  {
    id: 1,
    name: 'ALPHA-29',
    fullName: 'Demulsificante para Separación de Emulsiones',
    category: 'Tratamiento de Crudo',
    catalogType: 'Producción',
    description:
      'Demulsificante especializado con agentes tensoactivos que interrumpen la unión entre partículas de aceite y agua, permitiendo la separación efectiva de crudos emulsionados con alta resistencia a altas temperaturas.',
    applications: [
      'Separación de petróleo emulsionado con agua en pozos',
      'Procesamiento de crudo emulsionado en refinerías',
      'Clarificación y mejora del proceso de separación de crudo',
    ],
    specs: ['Separación rápida de emulsiones', 'Alta eficiencia térmica', 'Uso en refinerías', 'Clarificación de crudo'],
    badge: 'Alta Demanda',
    badgeColor: 'bg-accent-500',
    icon: 'ri-flask-line',
    stockDrum: 280,
    stockTote: 145,
  },
  {
    id: 2,
    name: 'ALPHAS-28',
    fullName: 'Antiespumante para Crudo y Procesos Industriales',
    category: 'Tratamiento de Crudo',
    catalogType: 'Producción',
    description:
      'Producto químico para el control y reducción de la formación de espuma en procesos de producción, almacenamiento y transporte de petróleo crudo, así como en refinerías y tratamiento de aguas residuales.',
    applications: [
      'Control de espuma en pozos petroleros durante producción',
      'Tanques de almacenamiento y transporte de crudo',
      'Destilación al vacío, extracción e hidrólisis ácida en refinerías',
      'Tratamiento de aguas residuales con aceites y grasas',
    ],
    specs: ['Control total de espuma', 'Pozos y tanques', 'Transporte de crudo', 'Procesos de refinería'],
    icon: 'ri-drop-line',
    stockDrum: 145,
    stockTote: 112,
  },
  {
    id: 3,
    name: 'ALPHA-41',
    fullName: 'Clarificante de Agua para Tratamiento de Efluentes',
    category: 'Tratamiento de Agua',
    catalogType: 'Producción',
    description:
      'Clarificante de alta calidad diseñado para el tratamiento de aguas turbias con sólidos suspendidos, logrando una sedimentación rápida y mejorando sustancialmente la calidad del agua tratada para riego, lavado y procesos industriales.',
    applications: [
      'Eliminación de sólidos suspendidos en aguas residuales',
      'Coagulación y floculación en tanques de sedimentación',
      'Reutilización de agua tratada para riego y lavado',
      'Reducción del impacto ambiental de efluentes industriales',
    ],
    specs: ['Sedimentación ultrarrápida', 'Reducción de turbiedad', 'Compatible con floculantes', 'Bajo impacto ambiental'],
    icon: 'ri-water-flash-line',
    stockDrum: 250,
    stockTote: 138,
  },
  {
    id: 4,
    name: 'ALPHA-42',
    fullName: 'Secuestrante de Oxígeno para Protección de Equipos',
    category: 'Inhibidores y Protectores',
    catalogType: 'Producción',
    description:
      'Aditivo químico que elimina el oxígeno presente en los sistemas, previniendo la corrosión en tuberías y equipos de perforación, evitando la formación de espuma en depósitos y la degradación de combustibles durante almacenamiento y transporte.',
    applications: [
      'Protección contra corrosión por oxígeno en tuberías',
      'Prevención de espuma en depósitos de petróleo y gas',
      'Protección contra degradación de combustibles almacenados',
    ],
    specs: ['Eliminación de O₂', 'Anticorrosivo eficaz', 'Protección de tuberías', 'Estabilidad de combustibles'],
    badge: 'Protección Avanzada',
    badgeColor: 'bg-primary-500',
    icon: 'ri-shield-line',
    stockDrum: 175,
    stockTote: 120,
  },
  {
    id: 5,
    name: 'ALPHA (pH)',
    fullName: 'Nivelador de pH para Fluidos de Perforación',
    category: 'Control de Fluidos',
    catalogType: 'Producción',
    description:
      'Aditivo formulado a base de ácidos y bases para ajustar y mantener el nivel de pH óptimo en fluidos de perforación y procesos industriales, previniendo corrosión, depósitos minerales, bacterias y reduciendo emulsiones no deseadas.',
    applications: [
      'Control de pH en fluidos de perforación de pozos de petróleo y gas',
      'Protección de tuberías y equipos contra escala y corrosión',
      'Reducción de formación de emulsiones en producción',
      'Control de contaminación ambiental en fluidos industriales',
    ],
    specs: ['Ajuste de pH preciso', 'Alta estabilidad temporal', 'Previene corrosión', 'Reduce emulsiones'],
    icon: 'ri-test-tube-line',
    stockDrum: 320,
    stockTote: 155,
  },
  {
    id: 6,
    name: 'ALPHA-46',
    fullName: 'Biocida de Amplio Espectro para Sistemas Petroleros',
    category: 'Control de Fluidos',
    catalogType: 'Producción',
    description:
      'Biocida avanzado para el control y eliminación de bacterias, hongos y algas en sistemas de producción y transporte de petróleo, previniendo obstrucciones, degradación de fluidos y contaminación ambiental en la industria petrolera.',
    applications: [
      'Protección de equipos de producción contra microorganismos',
      'Control de bacterias en sistemas de almacenamiento y transporte',
      'Mantenimiento de la calidad del petróleo en producción',
      'Minimización de contaminación ambiental en operaciones offshore y onshore',
    ],
    specs: ['Amplio espectro biocida', 'Antibacteriano-antifúngico', 'Control de algas', 'Bajo impacto ambiental'],
    badge: 'Alto Rendimiento',
    badgeColor: 'bg-accent-500',
    icon: 'ri-virus-line',
    stockDrum: 112,
    stockTote: 104,
  },
  {
    id: 7,
    name: 'ALPHA-43',
    fullName: 'Inhibidor de Corrosión para Superficies Metálicas',
    category: 'Inhibidores y Protectores',
    catalogType: 'Producción',
    description:
      'Compuesto que forma una capa protectora en superficies metálicas, evitando el contacto con oxígeno y elementos corrosivos en tuberías, equipos de perforación y estructuras de almacenamiento de petróleo y gas, prolongando la vida útil de los activos.',
    applications: [
      'Protección de tuberías y equipos de perforación de petróleo y gas',
      'Tratamiento del agua utilizada en fracturación hidráulica',
      'Protección de tanques y depósitos de almacenamiento',
    ],
    specs: ['Capa protectora metálica', 'Tuberías y equipos', 'Tanques de almacenamiento', 'Larga duración protectora'],
    badge: 'Esencial',
    badgeColor: 'bg-primary-500',
    icon: 'ri-shield-check-line',
    stockDrum: 160,
    stockTote: 130,
  },
  {
    id: 8,
    name: 'ALPHA-44',
    fullName: 'Inhibidor de Incrustación y Control de Escala Mineral',
    category: 'Inhibidores y Protectores',
    catalogType: 'Producción',
    description:
      'Formulación de polímeros y agentes químicos que previene la aglomeración de minerales y la formación de escala en tuberías, equipos de producción, sistemas de tratamiento de agua, calentadores y calderas industriales.',
    applications: [
      'Prevención de depósitos en tuberías y equipos de producción de petróleo y gas',
      'Protección de sistemas de tratamiento de agua en la industria petrolera',
      'Control de escala en calentadores y calderas industriales',
    ],
    specs: ['Antiescala mineral', 'Tuberías y equipos', 'Calentadores y calderas', 'Tratamiento de agua industrial'],
    badge: 'Máxima Eficiencia',
    badgeColor: 'bg-accent-500',
    icon: 'ri-filter-3-line',
    stockDrum: 190,
    stockTote: 140,
  },

  // ─── CATÁLOGO PERFORACIÓN 2025 ─────────────────────────────────────────
  {
    id: 9,
    name: 'ALFA INHIBIT®',
    fullName: 'Inhibidor de Arcillas — Lubricante para Lodos Base Agua',
    category: 'Inhibidores de Arcillas',
    catalogType: 'Perforación',
    description:
      'Supresor catiónico de la hidratación del espacio interlaminar con aporte de poli cationes de K y NH3+ activado con Surfactante. Esta mezcla produce no absorción de agua en el espacio interlaminar inhibiendo las arcillas reactivas. Efectivo en lodos base agua para reducir torque y arrastre en pozos direccionales. Estable a temperaturas superiores a los 160°C.',
    applications: [
      'Estabiliza arcillas y lutitas sensibles al agua',
      'Reduce torque y arrastre, y las tendencias a pegaduras por presión diferencial',
      'Efectivo reductor de filtrado; estimula la formación de revoques delgados y lisos',
      'Seguro en tierra y mar adentro — no tóxico',
      'Compatible con sistemas de lodo con amplio rango de salinidad, pH, calcio y sólidos totales',
    ],
    specs: ['Apariencia: Líquido Marrón', 'Densidad: 1.20 g/cc (10 Lbs/Bbl)', 'pH: 7.3', 'Empaque: Tambores 208 lts (547 Lbs/Tambor)'],
    treatment: 'Estabilizar arcillas/lutitas: 2-5 lpb. Reducción de torque y arrastre: 2-8 lpb. Mezclar a velocidad uniforme a través del embudo o bomba de succión de lodo. Un tambor (208 lts) cada 2 horas.',
    badge: 'Perforación 2026',
    badgeColor: 'bg-accent-500',
    icon: 'ri-stack-fill',
    stockDrum: 250,
    stockTote: 180,
  },
  {
    id: 10,
    name: 'POLY ALPHAS 7®',
    fullName: 'Inhibidor de Lutitas y Arcillas Reactivas — Triple Inhibición Catiónica',
    category: 'Inhibidores de Arcillas',
    catalogType: 'Perforación',
    description:
      'Mezcla sinérgica basada en la patentada síntesis química de Triple Inhibición Catiónica (NH4 + O7P3 + O2K), formulada como agente hidrofóbico/encapsulante de arcillas y lutitas reactivas a la hidratación, en lodos base agua: dispersos, semi-dispersos, lignosulfonatos, poliméricos, etc. Estable a temperaturas superiores a los 160°C.',
    applications: [
      'Ayuda a estabilizar arcillas y lutitas sensibles al agua',
      'Reduce torque y arrastre, y las tendencias a pegaduras por presión diferencial',
      'Efectivo reductor de filtrado; estimula la formación de revoques delgados y lisos',
      'Seguro en tierra y mar adentro — no tóxico',
      'Compatible con la mayoría de los aditivos para todo base agua',
    ],
    specs: ['Apariencia: Líquido Ámbar', 'Densidad: 1.0 – 1.05 g/cc', 'pH: 7.0', 'Empaque: Tambores 208 lts (547 Lbs/Tambor)'],
    treatment: 'Estabilizar agujeros y arcillas/lutitas: 0.25 – 0.5 lpb. Mezclar a velocidad uniforme a través de tanques de pre-mezcla con bomba de succión de lodo.',
    badge: 'Tecnología Patentada',
    badgeColor: 'bg-primary-500',
    icon: 'ri-stack-line',
    stockDrum: 210,
    stockTote: 165,
  },
  {
    id: 11,
    name: 'PX4-MO®',
    fullName: 'Surfactante Anti-Acreción de Crudos / Lubricante de Pozos',
    category: 'Surfactantes y Lubricantes',
    catalogType: 'Perforación',
    description:
      'Sistema de solventes y surfactantes diseñado para lavar pozos, suspender sólidos y ser transportados fuera del agujero. Utiliza un solvente y mezcla de surfactantes que forman una emulsión débil en agua y salmueras, en la cual los sólidos de perforación (arcillas, barita, limaduras) se humectan y son atraídos a las gotitas de la emulsión donde los contaminantes se mantienen en suspensión y sacados a superficie.',
    applications: [
      'Remueve, suspende y transporta sólidos y limaduras del pozo a superficie',
      'Los sólidos se humectan y emulsifican con la emulsión del agua',
      'Compatible con agua fresca, agua de mar o salmueras',
      'Limpieza de tanques de superficie, líneas y equipos para recibir salmueras filtradas',
      'Tratamiento de salmueras densas altamente contaminadas con sólidos',
    ],
    specs: ['Apariencia: Líquido Turbio Rojizo', 'Gravedad Específica: 1.02', 'Solubilidad: Emulsión a 15°C', 'Dosis: 5% – 15% V/V'],
    treatment: 'Las dosis empleadas son variables desde 5% a 15% V/V.',
    badge: undefined,
    badgeColor: undefined,
    icon: 'ri-bubble-chart-line',
    stockDrum: 130,
    stockTote: 100,
  },
  {
    id: 12,
    name: 'EZP-480®',
    fullName: 'Lubricante / Mejorador de la Velocidad de Penetración (ROP)',
    category: 'Surfactantes y Lubricantes',
    catalogType: 'Perforación',
    description:
      'Mezcla lubricante de polioles biodegradables que incrementa la velocidad de penetración y reduce el torque, al disminuir el embolamiento de la barrena y estabilizar las lutitas reactivas. Compatible con fluidos de perforación de agua dulce y salina. No tóxico y biodegradable, apto para perforación en región marina. Estable a 260°C (500°F).',
    applications: [
      'Aumenta la lubricidad e incrementa la velocidad de penetración',
      'No dañino para la zona productora — no tóxico y biodegradable',
      'Usado en todos los fluidos base agua',
      'Disminuye el torque y el arrastre en pozos direccionales y horizontales',
      'Reduce pegaduras por presión diferencial',
    ],
    specs: ['Apariencia: Líquido Marrón Oscuro y Espeso', 'Gravedad Específica: 1.15 – 1.22', 'pH: 7 – 8', 'Punto de Inflamación: &gt;121°C (250°F)', 'Solubilidad en Agua: 90%', 'Estable hasta 260°C (500°F)'],
    treatment: 'Tratamiento normal de 2.5 – 5 Lbs/bbls en volumen, directamente en los tanques de succión. Mantener la concentración para óptimos resultados, monitoreando la velocidad de penetración, dilución y control de sólidos.',
    badge: 'Biodegradable',
    badgeColor: 'bg-accent-500',
    icon: 'ri-speed-up-line',
    stockDrum: 240,
    stockTote: 195,
  },
  {
    id: 13,
    name: 'ALFATEX®',
    fullName: 'Liberador de Tuberías Atascadas en Perforación',
    category: 'Surfactantes y Lubricantes',
    catalogType: 'Perforación',
    description:
      'Mezcla altamente activa y soluble en aceite, ambientalmente segura, diseñada para despegar tuberías. Incrementa la velocidad de absorción del aceite y provoca la deshidratación del enjarre, tornándolo no cohesivo y permitiendo la penetración del líquido de aplicación.',
    applications: [
      'Liberación de tuberías de perforación atascadas por presión diferencial',
      'Deshidratación del enjarre para reducir fuerzas de adherencia',
      'Preparación en píldoras de liberación con mínimo 8 horas de reposo',
    ],
    specs: ['Líquido café rojizo', 'Punto inflamación: +141°F', 'Gravedad específica: 0.83 g/cc', 'Tambores 208 lts'],
    icon: 'ri-tools-line',
    stockDrum: 170,
    stockTote: 125,
  },
];

export const productCategories = [
  'Todos',
  'Tratamiento de Crudo',
  'Tratamiento de Agua',
  'Inhibidores y Protectores',
  'Control de Fluidos',
  'Inhibidores de Arcillas',
  'Surfactantes y Lubricantes',
];

export const catalogTypes = ['Todos', 'Producción', 'Perforación'];